export default [
    {
        key: 'android',
        icon: require('@/assets/images/fixed/icon_android_white@2x.png'),
        name: 'Android版'
    },
    {
        key: 'ios',
        icon: require('@/assets/images/fixed/icon_ios_black@2x.png'),
        name: 'iPhone版'
    },
]
